// src/pages/AffiliatePage.jsx
// Main affiliate program page

import React from 'react';
import { useAuth } from '../AuthContext';
import AffiliateDashboard from '../components/affiliate/AffiliateDashboard';
import PageBackground from '../components/PageBackground';

const affiliateBg = "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1500&q=80";

export default function AffiliatePage() {
  const { user } = useAuth();

  return (
    <PageBackground
      image={affiliateBg}
      boxed
      boxedWidth="max-w-7xl"
      overlayClass="bg-white/85 backdrop-blur"
      className="page-gutter"
    >
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">💰 Affiliate Program</h1>
        <p className="text-gray-600">Earn commissions by referring customers to our cooperative store</p>
      </div>
      
      <AffiliateDashboard userId={user?.uid} />
    </PageBackground>
  );
}
